// class CartDrawer extends HTMLElement {
//   constructor() {
//     super();

//     this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
//     this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
//     this.setHeaderCartIconAccessibility();
//   }

//   setHeaderCartIconAccessibility() {
//     const cartLink = document.querySelector('#cart-icon-bubble');
//     cartLink.setAttribute('role', 'button');
//     cartLink.setAttribute('aria-haspopup', 'dialog');
//     cartLink.addEventListener('click', (event) => {
//       event.preventDefault();
//       this.open(cartLink);
//     });
//     cartLink.addEventListener('keydown', (event) => {
//       if (event.code.toUpperCase() === 'SPACE') {
//         event.preventDefault();
//         this.open(cartLink);
//       }
//     });
//   }

//   open(triggeredBy) {
//     if (triggeredBy) this.setActiveElement(triggeredBy);
//     const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
//     if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
//     // here the animation doesn't seem to always get triggered. A timeout seem to help
//     setTimeout(() => {
//       this.classList.add('animate', 'active');
//     });

//     this.addEventListener(
//       'transitionend',
//       () => {
//         const containerToTrapFocusOn = this.classList.contains('is-empty')
//           ? this.querySelector('.drawer__inner-empty')
//           : document.getElementById('CartDrawer');
//         const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
//         trapFocus(containerToTrapFocusOn, focusElement);
//       },
//       { once: true }
//     );

//     document.body.classList.add('overflow-hidden');
//   }

//   close() {
//     this.classList.remove('active');
//     removeTrapFocus(this.activeElement);
//     document.body.classList.remove('overflow-hidden');
//   }

//   setSummaryAccessibility(cartDrawerNote) {
//     cartDrawerNote.setAttribute('role', 'button');
//     cartDrawerNote.setAttribute('aria-expanded', 'false');

//     if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
//       cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
//     }

//     cartDrawerNote.addEventListener('click', (event) => {
//       event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
//     });

//     cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
//   }

//   renderContents(parsedState) {
//     this.querySelector('.drawer__inner').classList.contains('is-empty') &&
//       this.querySelector('.drawer__inner').classList.remove('is-empty');
//     this.productId = parsedState.id;
//     this.getSectionsToRender().forEach((section) => {
//       const sectionElement = section.selector
//         ? document.querySelector(section.selector)
//         : document.getElementById(section.id);
//       sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
//     });

//     setTimeout(() => {
//       this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
//       this.open();
//     });
//   }

//   getSectionInnerHTML(html, selector = '.shopify-section') {
//     return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
//   }

//   getSectionsToRender() {
//     return [
//       {
//         id: 'cart-drawer',
//         selector: '#CartDrawer',
//       },
//       {
//         id: 'cart-icon-bubble',
//       },
//     ];
//   }

//   getSectionDOM(html, selector = '.shopify-section') {
//     return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
//   }

//   setActiveElement(element) {
//     this.activeElement = element;
//   }
// }

// customElements.define('cart-drawer', CartDrawer);

// class CartDrawerItems extends CartItems {
//   getSectionsToRender() {
//     return [
//       {
//         id: 'CartDrawer',
//         section: 'cart-drawer',
//         selector: '.drawer__inner',
//       },
//       {
//         id: 'cart-icon-bubble',
//         section: 'cart-icon-bubble',
//         selector: '.shopify-section',
//       },
//     ];
//   }
// }

// customElements.define('cart-drawer-items', CartDrawerItems);

/*
 * cart-drawer.js (self-contained build)
 *
 * Features: quantity +/- + remove, animated reward/progress bar, upsell carousel.
 * - Run-once IIFE so a duplicated <script> include can't redeclare.
 * - All cart writes (quantity change, remove, upsell add) go through ONE serial
 *   queue (cdEnqueue) so they never race each other and can't render a stale/empty
 *   cart.
 * - updateQuantity ignores NaN quantities, so an empty input can never be sent
 *   as quantity:0 (which Shopify interprets as "remove the line").
 */
(function () {
  if (window.__CART_DRAWER_INIT__) return;
  window.__CART_DRAWER_INIT__ = true;

  const CD_ROUTES = {
    change: (window.routes && window.routes.cart_change_url) || '/cart/change',
    add: (window.routes && window.routes.cart_add_url) || '/cart/add',
    update: (window.routes && window.routes.cart_update_url) || '/cart/update',
  };

  /* ------------------------------------------------------ serial write queue */
  /* Guarantees only one cart-mutating request runs at a time. */
  let cdCartBusy = false;
  const cdQueue = [];

  function cdEnqueue(taskFn) {
    cdQueue.push(taskFn);
    cdDrain();
  }

  function cdDrain() {
    if (cdCartBusy) return;
    const task = cdQueue.shift();
    if (!task) return;
    cdCartBusy = true;
    Promise.resolve()
      .then(task)
      .catch((e) => console.error('[cart] write failed', e))
      .finally(() => {
        cdCartBusy = false;
        cdDrain();
      });
  }

  /* ----------------------------------------------------------------- drawer */
  class CartDrawer extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      this.querySelector('#CartDrawer-Overlay')?.addEventListener('click', this.close.bind(this));
      this.setHeaderCartIconAccessibility();
    }

    setHeaderCartIconAccessibility() {
      const cartLink = document.querySelector('#cart-icon-bubble');
      if (!cartLink) return;
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLink);
      });
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    }

    open(triggeredBy) {
      if (triggeredBy) this.setActiveElement(triggeredBy);
      const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
      if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
      setTimeout(() => {
        this.classList.add('animate', 'active');
      });

      this.addEventListener(
        'transitionend',
        () => {
          const containerToTrapFocusOn = this.classList.contains('is-empty')
            ? this.querySelector('.drawer__inner-empty')
            : document.getElementById('CartDrawer');
          const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
          if (typeof trapFocus === 'function') trapFocus(containerToTrapFocusOn, focusElement);
        },
        { once: true }
      );

      document.body.classList.add('overflow-hidden');
      animateRewardBar(this);
    }

    close() {
      this.classList.remove('active');
      if (typeof removeTrapFocus === 'function') removeTrapFocus(this.activeElement);
      document.body.classList.remove('overflow-hidden');
    }

    setSummaryAccessibility(cartDrawerNote) {
      cartDrawerNote.setAttribute('role', 'button');
      cartDrawerNote.setAttribute('aria-expanded', 'false');
      if (cartDrawerNote.nextElementSibling?.getAttribute('id')) {
        cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
      }
      cartDrawerNote.addEventListener('click', (event) => {
        event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
      });
      if (typeof onKeyUpEscape === 'function') cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
    }

    /* Full replace of #CartDrawer — used by the upsell add-to-cart path. */
    renderContents(parsedState) {
      const inner = this.querySelector('.drawer__inner');
      if (inner?.classList.contains('is-empty')) inner.classList.remove('is-empty');
      this.productId = parsedState.id;
      const wasOpen = this.classList.contains('active');
      const kept = keepDrawerState();
      this.getSectionsToRender().forEach((section) => {
        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
        if (!sectionElement || !parsedState.sections?.[section.id]) return;
        sectionElement.innerHTML = getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      });
      this.classList.remove('is-empty');
      restoreDrawerState(kept, wasOpen);
      initUpsellSlider();
      setTimeout(() => {
        this.querySelector('#CartDrawer-Overlay')?.addEventListener('click', this.close.bind(this));
        if (!wasOpen) this.open();
      });
    }

    getSectionsToRender() {
      return [
        { id: 'cart-drawer', selector: '#CartDrawer' },
        { id: 'cart-icon-bubble' },
      ];
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      return getSectionInnerHTML(html, selector);
    }

    setActiveElement(element) {
      this.activeElement = element;
    }
  }
  if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', CartDrawer);

  /* Shared helper (not tied to any base class). */
  function getSectionInnerHTML(html, selector = '.shopify-section') {
    const node = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return node ? node.innerHTML : '';
  }

  /* Keeps the scroll position, bar width and app widget height across a drawer re-render. */
  function keepDrawerState() {
    const drawer = document.getElementById('CartDrawer');
    const slot = drawer?.querySelector('.cd-upsell-slot');
    const fill = drawer?.querySelector('.cd-bar__fill');
    return {
      scrollTop: drawer?.querySelector('cart-drawer-items')?.scrollTop || 0,
      widgetHeight: slot && slot.querySelector('.essential-upsell-cross-sell-block > *') ? slot.offsetHeight : 0,
      barWidth: fill ? fill.style.width : null,
    };
  }

  function restoreDrawerState(kept, animateBar = true) {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    const slot = drawer.querySelector('.cd-upsell-slot');
    if (slot && kept.widgetHeight) holdHeightWhileRebuilding(slot, kept.widgetHeight);
    const scroller = drawer.querySelector('cart-drawer-items');
    if (scroller) scroller.scrollTop = kept.scrollTop;
    if (animateBar) animateRewardBar(drawer, kept.barWidth);
  }

  /* The upsell app rebuilds its widget after every re-render; hold its old height until it settles. */
  function holdHeightWhileRebuilding(element, height) {
    element.style.height = `${height}px`;
    element.style.overflow = 'hidden';

    let settle;
    const release = () => {
      observer.disconnect();
      clearTimeout(settle);
      clearTimeout(limit);
      element.style.height = '';
      element.style.overflow = '';
    };
    const schedule = () => {
      clearTimeout(settle);
      const rendered = element.querySelector('[data-essential-upsell-element="add-to-cart-button"]');
      settle = setTimeout(release, rendered ? 300 : 1500);
    };
    const observer = new MutationObserver(schedule);
    observer.observe(element, { childList: true, subtree: true, attributes: true, characterData: true });
    schedule();
    const limit = setTimeout(release, 4000);
  }

  /* Animate the reward/progress bar to its server-rendered target width. */
  function animateRewardBar(root = document, from = '0%') {
    const fill = (root.querySelector ? root : document).querySelector('.cd-bar__fill');
    if (!fill) return;
    const target = fill.style.width || '0%';
    if (from === target) return;
    fill.style.width = from || '0%';
    requestAnimationFrame(() => requestAnimationFrame(() => { fill.style.width = target; }));
  }

  /* --------------------------------------------------- upsell Swiper slider */
  let cdUpsellSwiper = null;

  const CD_UPSELL_SWIPER_OPTS = {
    // grabCursor: true,
    slidesPerView: 1.1,
    spaceBetween: 16,
    speed: 600,
    // freeMode: true,
  };

  function initUpsellSlider() {
    if (cdUpsellSwiper) {
      try { cdUpsellSwiper.destroy(true, true); } catch (e) { /* element already gone */ }
      cdUpsellSwiper = null;
    }

    const el = document.querySelector('.cd_upsell_slider_product');
    if (!el || el.classList.contains('swiper-initialized')) return;

    if (typeof Swiper === 'undefined') {
      if (initUpsellSlider._tries === undefined) initUpsellSlider._tries = 0;
      if (initUpsellSlider._tries++ < 20) setTimeout(initUpsellSlider, 100);
      return;
    }
    initUpsellSlider._tries = 0;
    cdUpsellSwiper = new Swiper(el, CD_UPSELL_SWIPER_OPTS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUpsellSlider);
  } else {
    initUpsellSlider();
  }

  /* ----------------------------------------------- standalone drawer items */
  class CartDrawerItems extends HTMLElement {
    constructor() {
      super();
      this.pendingInput = null;
      this._commitTimer = null;
      this.addEventListener('click', this.onStepClick.bind(this));
      this.addEventListener('change', this.onChange.bind(this));
    }

    disconnectedCallback() {
      // Cancel a pending debounced commit so a replaced row can't fire a stale change.
      clearTimeout(this._commitTimer);
    }

    get lineItemStatusElement() {
      return document.getElementById('CartDrawer-LineItemStatus');
    }

    onStepClick(event) {
      const removeBtn = event.target.closest('.cd-remove-btn');
      if (removeBtn) {
        event.preventDefault();
        this.updateQuantity(removeBtn.dataset.index, 0, removeBtn.dataset.key);
        return;
      }

      const button = event.target.closest('button[name="plus"], button[name="minus"]');
      if (!button) return;
      event.preventDefault();

      const stepper = button.closest('.cd-qty');
      const input = stepper?.querySelector('.cd-qty__input');
      if (!input) return;

      const step = parseInt(input.step, 10) || 1;
      const min = input.min !== '' ? parseInt(input.min, 10) : 0;
      const max = input.max !== '' ? parseInt(input.max, 10) : Infinity;
      let value = parseInt(input.value, 10) || 0;

      value = button.name === 'plus' ? value + step : value - step;
      if (value < min) value = min;
      if (value > max) value = max;
      if (value === (parseInt(input.value, 10) || 0)) return;

      input.value = value;
      this.scheduleUpdate(input);
    }

    onChange(event) {
      const input = event.target.closest('.cd-qty__input');
      if (!input) return;
      this.scheduleUpdate(input);
    }

    scheduleUpdate(input) {
      this.pendingInput = input;
      clearTimeout(this._commitTimer);
      this._commitTimer = setTimeout(() => {
        const i = this.pendingInput;
        if (i) this.updateQuantity(i.dataset.index, i.value, i.dataset.key);
      }, 350);
    }

    getSectionsToRender() {
      return [
        { id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' },
        { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
      ];
    }

    /* Public entry: validate, then enqueue the actual write so it can't race. */
    updateQuantity(line, quantity, key) {
      if (line == null) return;
      const qty = parseInt(quantity, 10);
      if (Number.isNaN(qty) || qty < 0) return; // never send a blank/NaN qty (would remove the line)

      this.enableLoading(line);
      cdEnqueue(() => this._doUpdateQuantity(line, qty, key));
    }

    _doUpdateQuantity(line, qty, key) {
      const body = JSON.stringify({
        [key ? 'id' : 'line']: key || line,
        quantity: qty,
        sections: this.getSectionsToRender().map((s) => s.section),
        sections_url: window.location.pathname,
      });

      return fetch(`${CD_ROUTES.change}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body,
      })
        .then((response) => response.json())
        .then((parsedState) => {
          if (parsedState.errors) {
            this.showLineError(line, parsedState.errors);
            return;
          }
          if (parsedState.status) {
            this.showLineError(line, parsedState.description || parsedState.message);
            return;
          }
          this.renderSections(parsedState);
          this.announce(parsedState);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-drawer-items', cartData: parsedState });
          }
        })
        .catch(() => {
          this.showCartError();
        })
        .finally(() => {
          this.disableLoading(line);
        });
    }

    renderSections(parsedState) {
      const kept = keepDrawerState();
      this.getSectionsToRender().forEach((section) => {
        const container = document.getElementById(section.id);
        if (!container || !parsedState.sections?.[section.section]) return;
        const target = container.querySelector(section.selector) || container;
        target.innerHTML = getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      });

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        cartDrawer.classList.toggle('is-empty', parsedState.item_count === 0);
        const inner = cartDrawer.querySelector('.drawer__inner');
        if (inner) inner.classList.toggle('is-empty', parsedState.item_count === 0);
      }
      restoreDrawerState(kept);
      initUpsellSlider();
    }

    enableLoading(line) {
      document.getElementById('CartDrawer')?.classList.add('cart__items--disabled');
      document.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`).forEach((el) => el.classList.remove('hidden'));
      this.lineItemStatusElement?.setAttribute('aria-hidden', 'false');
      document.activeElement?.blur?.();
    }

    disableLoading() {
      document.getElementById('CartDrawer')?.classList.remove('cart__items--disabled');
    }

    showLineError(line, message) {
      this.disableLoading(line);
      const errorEl = document.getElementById(`CartDrawer-LineItemError-${line}`);
      const textEl = errorEl?.querySelector('.cart-item__error-text');
      if (textEl) textEl.textContent = Array.isArray(message) ? message.join(' ') : message;
    }

    showCartError() {
      this.disableLoading();
      const errors = document.getElementById('CartDrawer-CartErrors');
      if (errors) errors.textContent = 'Something went wrong updating your cart. Please try again.';
    }

    announce(parsedState) {
      const live = document.getElementById('CartDrawer-LiveRegionText');
      if (live) live.textContent = `Cart updated. ${parsedState.item_count} items.`;
    }
  }
  if (!customElements.get('cart-drawer-items')) customElements.define('cart-drawer-items', CartDrawerItems);

  /* ------------------------------------------------------------ free gift */
  function cdGiftRequest(route, payload) {
    const items = document.querySelector('cart-drawer-items');
    const sections = items ? items.getSectionsToRender().map((s) => s.section) : ['cart-drawer', 'cart-icon-bubble'];

    return fetch(`${route}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...payload, sections, sections_url: window.location.pathname }),
    })
      .then((response) => response.json())
      .then((parsed) => {
        if (parsed.status) {
          const error = new Error(parsed.description || parsed.message);
          error.shopifyMessage = parsed.description || parsed.message;
          throw error;
        }
        const drawerItems = document.querySelector('cart-drawer-items');
        if (drawerItems && parsed.sections) drawerItems.renderSections(parsed);
        window.__themeCartSyncedAt = Date.now();
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-free-gift', cartData: parsed });
        }
        return parsed;
      });
  }

  const CD_GIFT_SEEN_KEY = 'cd-gift-seen';
  let cdGiftSeen = false;

  function cdReadGiftSeen() {
    try {
      return cdGiftSeen || sessionStorage.getItem(CD_GIFT_SEEN_KEY) === '1';
    } catch (e) {
      return cdGiftSeen;
    }
  }

  function cdWriteGiftSeen(seen) {
    cdGiftSeen = seen;
    try {
      if (seen) sessionStorage.setItem(CD_GIFT_SEEN_KEY, '1');
      else sessionStorage.removeItem(CD_GIFT_SEEN_KEY);
    } catch (e) { /* storage blocked */ }
  }

  /* Keeps the gift to one line at quantity 1, and only while the cart qualifies.
   * A gift with nothing to choose is added once each time the cart qualifies, so a
   * customer who removes it gets the picker instead of having it added back. */
  class CartFreeGift extends HTMLElement {
    connectedCallback() {
      const updates = {};
      const giftKey = this.dataset.giftKey;
      const giftQty = parseInt(this.dataset.giftQty, 10) || 0;
      const qualifies = this.dataset.qualifies === 'true';

      if (!qualifies) cdWriteGiftSeen(false);
      else if (giftKey) cdWriteGiftSeen(true);

      if (giftKey && !qualifies) updates[giftKey] = 0;
      else if (giftKey && giftQty > 1) updates[giftKey] = 1;
      (this.dataset.extraKeys || '')
        .split(',')
        .filter(Boolean)
        .forEach((key) => {
          updates[key] = 0;
        });

      const signature = JSON.stringify(updates);
      if (signature === '{}') {
        CartFreeGift.lastFix = null;
        if (qualifies && !giftKey) this.autoAdd();
        return;
      }
      if (signature === CartFreeGift.lastFix) return;
      CartFreeGift.lastFix = signature;
      cdEnqueue(() => cdGiftRequest(CD_ROUTES.update, { updates }).catch((e) => console.error('[free-gift]', e)));
    }

    autoAdd() {
      const variantId = Number(this.dataset.autoVariantId);
      if (!variantId || cdReadGiftSeen()) return;
      cdWriteGiftSeen(true);

      const button = document.querySelector(`cart-gift-picker [data-gift-variant-id="${variantId}"]`);
      button?.classList.add('is-loading');
      button?.setAttribute('disabled', 'disabled');

      cdEnqueue(() =>
        cdGiftRequest(CD_ROUTES.add, { id: variantId, quantity: 1 }).catch((e) => {
          console.error('[free-gift]', e);
          button?.classList.remove('is-loading');
          button?.removeAttribute('disabled');
        })
      );
    }
  }
  if (!customElements.get('cart-free-gift')) customElements.define('cart-free-gift', CartFreeGift);

  let cdGiftWasLocked = null;

  class CartGiftPicker extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('change', this.onSelect.bind(this));
    }

    onSelect(event) {
      const select = event.target.closest('[data-gift-select]');
      if (!select) return;

      const option = select.options[select.selectedIndex];
      const row = select.closest('.cd-gift__row') || this;
      const button = row.querySelector('.cd-gift__add-btn');
      const swatch = row.querySelector('[data-gift-swatch]');
      const image = row.querySelector('[data-gift-image]');

      if (button) {
        button.dataset.giftVariantId = select.value;
        option.disabled ? button.setAttribute('disabled', 'disabled') : button.removeAttribute('disabled');
      }
      if (swatch) swatch.style.backgroundColor = option.dataset.swatch || '';
      if (image && option.dataset.image) image.src = option.dataset.image;
    }

    connectedCallback() {
      const locked = this.classList.contains('cd-gift--locked');
      if (cdGiftWasLocked === true && !locked) this.classList.add('is-just-unlocked');
      cdGiftWasLocked = locked;
    }

    onClick(event) {
      const option = event.target.closest('[data-gift-variant-id]');
      if (!option || option.disabled || this.busy) return;

      const available = Array.from(this.querySelectorAll('[data-gift-variant-id]:not([disabled]), [data-gift-select]:not([disabled])'));
      this.busy = true;
      option.classList.add('is-loading');
      available.forEach((button) => button.setAttribute('disabled', 'disabled'));

      cdEnqueue(() =>
        cdGiftRequest(CD_ROUTES.add, { id: Number(option.dataset.giftVariantId), quantity: 1 }).catch((e) => {
          const errors = document.getElementById('CartDrawer-CartErrors');
          if (errors) errors.textContent = e.shopifyMessage || 'Could not add your free gift. Please try again.';
          this.busy = false;
          option.classList.remove('is-loading');
          available.forEach((button) => button.removeAttribute('disabled'));
        })
      );
    }
  }
  if (!customElements.get('cart-gift-picker')) customElements.define('cart-gift-picker', CartGiftPicker);

  /* --------------------------------------------------- upsell add-to-cart */
  class CartUpsellCard extends HTMLElement {
    constructor() {
      super();
      this.variants = this._readVariants();
      this.selects = Array.from(this.querySelectorAll('.cd-select__input'));
      this.addButton = this.querySelector('.cd-card__add');
      this.priceEl = this.querySelector('[data-upsell-price]');
      this.compareEl = this.querySelector('[data-upsell-compare]');
      this.imageEl = this.querySelector('[data-upsell-image]');
      this.badgeEl = this.querySelector('[data-upsell-badge]');
      this.addLabelEl = this.querySelector('.cd-card__add-label');
      this.addIconEl = this.querySelector('.cd-card__add-icon');
      this.preorderLabels = this._readPreorderLabels();
    }

    connectedCallback() {
      this.selects.forEach((sel) => sel.addEventListener('change', () => this._onOptionChange()));
      this.addButton?.addEventListener('click', () => this._addToCart());
      this._updateSwatches();
    }

    _updateSwatches() {
      this.querySelectorAll('select[data-has-swatch]').forEach((sel) => {
        const opt = sel.options[sel.selectedIndex];
        const color = opt && opt.dataset ? opt.dataset.swatch : '';
        const sw = sel.closest('.cd-select__control')?.querySelector('[data-upsell-swatch]');
        if (sw && color) sw.style.backgroundColor = color;
      });
    }

    _readVariants() {
      try {
        return JSON.parse(this.querySelector('.cd-card__variants').textContent);
      } catch (e) {
        return [];
      }
    }

    _readPreorderLabels() {
      try {
        return JSON.parse(this.addButton?.dataset.preorderLabels || '{}');
      } catch (e) {
        return {};
      }
    }

    _applyPreorderLabel(variant) {
      if (!this.addLabelEl) return;
      const label = variant ? this.preorderLabels[variant.id] : '';

      this.addLabelEl.textContent = label || 'Add';
      if (this.addIconEl) this.addIconEl.hidden = Boolean(label);
      if (this.addButton) this.addButton.setAttribute('aria-label', label || 'Add');
    }

    _selectedVariant() {
      if (!this.selects.length) return this.variants[0];
      const chosen = [];
      this.selects
        .slice()
        .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition))
        .forEach((sel) => {
          chosen[Number(sel.dataset.optionPosition) - 1] = sel.value;
        });
      return this.variants.find((v) => chosen.every((value, i) => v[`option${i + 1}`] === value));
    }

    _formatMoney(cents) {
      const format = this.dataset.moneyFormat || '${{amount}}';
      return format.replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2));
    }

    _onOptionChange() {
      this._updateSwatches();
      const variant = this._selectedVariant();
      if (!variant) {
        this.addButton?.setAttribute('disabled', 'disabled');
        if (this.addButton) this.addButton.dataset.variantId = '';
        this._applyPreorderLabel(null);
        return;
      }
      this.addButton.dataset.variantId = variant.id;
      variant.available ? this.addButton.removeAttribute('disabled') : this.addButton.setAttribute('disabled', 'disabled');
      this._applyPreorderLabel(variant);

      if (this.priceEl) this.priceEl.textContent = this._formatMoney(variant.price);
      if (this.compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          this.compareEl.textContent = this._formatMoney(variant.compare_at_price);
          this.compareEl.hidden = false;
          if (this.badgeEl) {
            const pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
            this.badgeEl.textContent = `${pct}% OFF`;
            this.badgeEl.hidden = false;
          }
        } else {
          this.compareEl.hidden = true;
          if (this.badgeEl) this.badgeEl.hidden = true;
        }
      }
      if (this.imageEl && variant.featured_image?.src) {
        this.imageEl.src = variant.featured_image.src.replace(/(\.[^.]+)(\?.*)?$/, '_400x$1$2');
      }
    }

    _addToCart() {
      const variantId = this.addButton?.dataset.variantId;
      if (!variantId) return;

      this.addButton.classList.add('is-loading');
      this.addButton.setAttribute('disabled', 'disabled');
      cdEnqueue(() => this._doAdd(variantId));
    }

    _doAdd(variantId) {
      const cartDrawer = document.querySelector('cart-drawer');
      const cartItems = document.querySelector('cart-drawer-items');
      const sections = cartItems
        ? cartItems.getSectionsToRender().map((s) => s.section || s.id)
        : ['cart-drawer', 'cart-icon-bubble'];

      return fetch(`${CD_ROUTES.add}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity: 1, sections, sections_url: window.location.pathname }),
      })
        .then((response) => response.json())
        .then((parsed) => {
          if (parsed.status) {
            this._showError(parsed.description || parsed.message);
            return;
          }
          if (cartDrawer && parsed.sections) cartDrawer.renderContents(parsed);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-upsell-card', cartData: parsed });
          }
        })
        .catch((err) => {
          this._showError();
          console.error('[cart-upsell] add failed', err);
        })
        .finally(() => {
          this.addButton?.classList.remove('is-loading');
          this.addButton?.removeAttribute('disabled');
        });
    }

    _showError(message) {
      const errors = document.getElementById('CartDrawer-CartErrors');
      if (errors) errors.textContent = message || 'Could not add to cart. Please try again.';
    }
  }
  if (!customElements.get('cart-upsell-card')) customElements.define('cart-upsell-card', CartUpsellCard);
})();